'use client'
import type { PropsWithChildren } from 'react'

const RiskCurationLayout = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="gap-sm flex scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col"
      id="risk-curation-section"
    >
      <span className="text-foreground text-sm">Risk Curation</span>
      {children}
    </div>
  )
}

export default RiskCurationLayout
